"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useAction(selector) {
  const {
    item: action,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.Action,
    selector,
    (integrationApp) => selector ? integrationApp.action(selector) : void 0
  );
  async function reset() {
    await accessor?.reset();
    await refresh();
  }
  return { action, reset, refresh, accessor, ...rest };
}

export { useAction };
